import { FormattedMessage } from 'react-intl';

import { FilterSeparator, FilterWidget } from '@sorare/core/src/lib/filters';

import { RefinePrice } from './RangeSlider';
import { RefineBundledSale, RefineRarity } from './RefineList';
import { RefineSettlementWallets } from './RefineSettlementWallets';

export const RarityGroup = {
  slug: 'rarity',
  filters: [RefineRarity],
};

export const PriceGroup = {
  slug: 'price',
  filters: [RefinePrice({ startsOpen: true })],
};

export const SaleGroup = {
  slug: 'sale',
  title: <FormattedMessage id="cardFilters.sale.title" defaultMessage="Sale" />,
  filters: [RefineBundledSale],
};

export const AcceptedCurrencyGroup = {
  slug: 'accepted-currency',
  title: <FormattedMessage id="cardFilters.sale.title" defaultMessage="Sale" />,
  filters: [RefineSettlementWallets],
};
export const CollectibleGroup = (
  filters: (FilterWidget | FilterSeparator)[]
) => ({
  slug: 'collectibles',
  title: (
    <FormattedMessage
      id="cardFilters.collectibles.title"
      defaultMessage="Collectibles"
    />
  ),
  filters,
});
